import { interestsFullNameMap } from "../models/label-maps";

export const mapInterestFullName = (name: string): string => interestsFullNameMap[name] ?? name;
